import React from 'react';
import MicrosoftofficeCard from './microsoftofficeCard';
import img1 from '../../../public/images/FOTO-2.3-768x768.png';

import Button from '../Button';

const Microsoftoffice = () => {
  return (
    <div className="min-h-screen container mx-auto flex flex-col items-center justify-center mt-16 mb-8 px-5 lg:px-0">
      <h1 className="text-4xl lg:text-5xl font-bold text-center text-blue mb-10">
        Microsoft Office
      </h1>

      <div className="w-full lg:w-3/4 space-y-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <MicrosoftofficeCard
            img={img1}
            title0=""
            title1=""
            description=""
            items={[
            ]}
          />
          <MicrosoftofficeCard
            title0=""
            title1="Microsoft Office 365"
            description=""
            items={[
'Licencia de Office 365 A1 Plus.',
'5 dispositivos.',
'1 TB / 5 TB.',
'Windows, Mac os y Andoroid.',
'Uso de por vida, soporte posventa permanente.',
'Activación en 1 Hora.',
'Estructura: usuario@nombre de dominio fijo, solo se puede personalizar el usuario.'

            ]}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <MicrosoftofficeCard
            title0=" 1TB"
            title1="Office 365"
            title2="Licencia Permanente"
            title3="S/ 60"
            title4="S/ 30"
            title5="Mensual sin IGV"
            description=""
            items={[
              'Soporte Via WhatsApp 24x7.',
            ]}
          />
          <MicrosoftofficeCard
            title0=" 5TB"
            title1="Office 365"
            title2="Licencia Permanente"
            title3="S/ 80"
            title4="S/ 40"
            title5="Mensual sin IGV"
            description=""
            items={[
              'Soporte Via WhatsApp 24x7.',
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default Microsoftoffice;
